import { SET_GDPR, SET_COUNTRY_CODE, SET_BROWSER_LANGUAGE } from './actions';

const INITIAL_STATE = {
  isGDPR: true,
  countryCode: null,
  browserLanguage: 'en',
};

export const locale = (state = INITIAL_STATE, { type, payload }: any = {}) => {
  switch (type) {
    case SET_GDPR:
    case SET_COUNTRY_CODE:
      return { ...state, ...payload };
    case SET_BROWSER_LANGUAGE:
      return { ...state, ...payload };
    default:
      return state;
  }
};
